import api from "./axiosInstance";
import { ApiBaseResponse } from "models/ApiBaseResponse";
import { ReceiveUserMessageRequest, ReceiveUserMessageResponse, StartNewSessionResponse } from "@models/ChatAIModels";

const API_URL = "/ChatAI";

const ChatAIApi = {
  startNewSession: async (
    serviceId: string,
    serviceToken: string,
    Channel: number
  ): Promise<StartNewSessionResponse | null> => {
    try {
      const response = await api.get<{ content: StartNewSessionResponse }>(
        `${API_URL}/StartNewSession?serviceId=${serviceId}&serviceToken=${serviceToken}&Channel=${Channel}`
      );
      return response.data.content;
    } catch (error) {
      console.error(`Error startNewSession:`, error);
      return null;
    }
  },
  receiveUserMessageResponse: async (
    data: ReceiveUserMessageRequest
  ): Promise<ApiBaseResponse<ReceiveUserMessageResponse> | null> => {
    try {
      const response = await api.post<ApiBaseResponse<ReceiveUserMessageResponse>>(
        `${API_URL}/ReceiveUserMessage`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error receiveUserMessageResponse:`, error);
      return null;
    }
  },
};

export default ChatAIApi;
